// generate the products as a carousel if > 3 -- otherwise single.
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import {TextRegular, TextSmall, TextTiny, TextSpace } from '@components/elements/TextStyles';
import { BasicTextInput, Logo } from '@as_core/account/forms/FormStyles';
import { APP_CONFIG } from '@app_config/app';
import TextButton from '@components/controls/TextButton/TextButton';

interface PropsI {
  item: any;
  onAddToCart: (item:string, quantity: number) => void;
}

const debug = false;
const ProductCard = (props:PropsI) => {
  const { item, onAddToCart } = props;
  const [quantity, setQuantity] = useState<number>(1);

  debug && console.log('ProductCard | item:', props.item);

  const handleInputChange = (e) => {
    setQuantity(Number(e.target.value))
  }

  const handleAdd = () => {
    if (quantity) onAddToCart(item.catalogNumber, quantity);
  }

  return(
   <CardContainer>
     <Row><Logo><img src={APP_CONFIG.logo} alt='logo' /></Logo></Row>
     <Row><TextSmall color={'primary'}>{item.name}</TextSmall></Row>
     <Row><TextTiny color={'secondary'}>{item.description}</TextTiny></Row>
     <Row>
       <TextTiny color={'accent'}>Catalog #:</TextTiny>
       <TextTiny>{item.catalogNumber}</TextTiny>
     </Row>
     <Row>
       <TextRegular color={'accent'}>Credits in Unit:</TextRegular>
       <TextSpace />
       <TextRegular color={'primary'}>{item.credits}</TextRegular>
     </Row>
     <Row>
       <TextRegular color={'accent'}>Unit Price:</TextRegular>
       <TextSpace />
       <TextRegular color={'primary'}>{item.price / 100} {item.currency}</TextRegular>
     </Row>
     <Row>
       <TextSmall color={'accent'}>Units to Purchase:</TextSmall>
       <QuantityContainer>
         <BasicTextInput
           id='quantity'
           type='text'
           name='username'
           placeholder='Enter email as username ...'
           autoComplete='username'
           value={quantity}
           onChange={handleInputChange}
         />
       </QuantityContainer>
     </Row>
     <Row>
       <TextButton label={'Add to Cart'} onClick={handleAdd} />
     </Row>
   </CardContainer>
  )
}

export default ProductCard;

const CardContainer = styled.div`
  display: flex;
  border-radius: 15px;
  flex-direction: column;
  padding: 10px;
  border: 1px solid ${(p) => p.theme.palette.accentPrimary };
  background-color: ${(p) => p.theme.palette.backgroundTertiary };
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 3px 0;
`;

const QuantityContainer = styled.div`
  display: flex;
  margin-left: 5px;
  width: 50px;
`;